(function () {
  var initializedFinders = new WeakSet()
  var initializedCollections = new WeakSet()
  var initializedHeroes = new WeakSet()
  var initializedProductBanners = new WeakSet()

  function bootHero (hero) {
    if (initializedHeroes.has(hero)) return
    initializedHeroes.add(hero)

    var hotspots = Array.from(hero.querySelectorAll('[data-okdo-hero-hotspot]'))
    var panel = hero.querySelector('[data-okdo-hero-feature-panel]')
    var title = hero.querySelector('[data-okdo-hero-feature-title]')
    var text = hero.querySelector('[data-okdo-hero-feature-text]')
    var close = hero.querySelector('[data-okdo-hero-feature-close]')
    if (!hotspots.length || !panel || !title || !text || !close) return

    function closePanel () {
      panel.hidden = true
      hotspots.forEach(function (hotspot) {
        hotspot.setAttribute('aria-expanded', 'false')
        hotspot.classList.remove('is-active')
      })
    }

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', function () {
        var wasOpen = hotspot.getAttribute('aria-expanded') === 'true'
        closePanel()
        if (wasOpen) return
        title.textContent = hotspot.dataset.title || ''
        text.textContent = hotspot.dataset.text || ''
        hotspot.setAttribute('aria-expanded', 'true')
        hotspot.classList.add('is-active')
        panel.hidden = false
        window.okdoTrack?.('okdo_3d_hotspot_open', {
          feature: hotspot.dataset.title || 'feature',
        })
      })
    })

    close.addEventListener('click', closePanel)
    hero.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel()
    })
    hero.addEventListener('okdo:chair3d-intro-complete', function () {
      hero.classList.add('is-hotspot-ready')
    })
  }

  function bootFinder (finder) {
    if (initializedFinders.has(finder)) return
    initializedFinders.add(finder)

    var tabs = Array.from(finder.querySelectorAll('[data-okdo-finder-tab]'))
    var panels = Array.from(finder.querySelectorAll('[data-okdo-finder-panel]'))
    if (!tabs.length || tabs.length !== panels.length) return

    function activate (index, focus) {
      tabs.forEach(function (tab, tabIndex) {
        var selected = tabIndex === index
        tab.setAttribute('aria-selected', selected ? 'true' : 'false')
        tab.tabIndex = selected ? 0 : -1
        panels[tabIndex].hidden = !selected
      })
      if (focus) tabs[index].focus()
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false)
        window.okdoTrack?.('okdo_chair_finder_select', {
          audience: tab.textContent.trim(),
        })
      })
      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
        event.preventDefault()
        var nextIndex = index
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length
        if (event.key === 'Home') nextIndex = 0
        if (event.key === 'End') nextIndex = tabs.length - 1
        activate(nextIndex, true)
      })
    })
  }

  function bootProductBanner (root) {
    if (initializedProductBanners.has(root)) return
    initializedProductBanners.add(root)

    var toggle = root.querySelector('[data-okdo-product-banner-toggle]')
    if (!toggle) return

    function setInspecting (active) {
      root.classList.toggle('is-inspecting', active)
      toggle.setAttribute('aria-pressed', active ? 'true' : 'false')
    }

    toggle.addEventListener('click', function () {
      var touchInteraction = window.matchMedia('(hover: none), (pointer: coarse), (max-width: 42rem)').matches
      if (!touchInteraction) return
      var active = !root.classList.contains('is-inspecting')
      setInspecting(active)
      if (active) {
        window.okdoTrack?.('okdo_product_banner_reveal', {
          view: 'white-background-15-degree',
        })
      }
    })

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setInspecting(false)
        toggle.blur()
      }
    })
  }

  function escapeHtml (value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;')
  }

  function bootCollection (root) {
    if (initializedCollections.has(root)) return
    initializedCollections.add(root)

    var filterToggle = root.querySelector('[data-okdo-filter-toggle]')
    var filterPanel = root.querySelector('[data-okdo-filter-panel]')
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function () {
        var open = filterToggle.getAttribute('aria-expanded') === 'true'
        filterToggle.setAttribute('aria-expanded', open ? 'false' : 'true')
        filterPanel.classList.toggle('is-open', !open)
      })
    }

    root.querySelectorAll('[data-okdo-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        select.form?.submit()
      })
    })

    var toggles = Array.from(root.querySelectorAll('[data-okdo-compare-toggle]'))
    var bar = root.querySelector('[data-okdo-compare-bar]')
    var count = root.querySelector('[data-okdo-compare-count]')
    var names = root.querySelector('[data-okdo-compare-names]')
    var openButton = root.querySelector('[data-okdo-compare-open]')
    var clearButton = root.querySelector('[data-okdo-compare-clear]')
    var dialog = root.querySelector('[data-okdo-compare-dialog]')
    var closeButton = root.querySelector('[data-okdo-compare-close]')
    var content = root.querySelector('[data-okdo-compare-content]')
    if (!toggles.length || !bar || !count || !names || !openButton || !clearButton || !dialog || !closeButton || !content) return

    var selected = []
    var storageKey = 'okdo-chair-compare:' + window.location.pathname

    function getCardData (toggle) {
      var card = toggle.closest('[data-okdo-compare-card]')
      if (!card) return null
      return {
        id: card.dataset.productId || '',
        title: card.dataset.productTitle || '',
        url: card.dataset.productUrl || '',
        price: card.dataset.productPrice || '',
        image: card.dataset.productImage || '',
        bestFor: card.dataset.productBestFor || '',
        colours: card.dataset.productColours || '0',
        availability: card.dataset.productAvailability || '',
      }
    }

    function save () {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(selected.map(function (item) { return item.id })))
      } catch (error) {
        // Comparison remains available for the current page even when storage is blocked.
      }
    }

    function renderBar () {
      count.textContent = String(selected.length)
      names.textContent = selected.length
        ? selected.map(function (item) { return item.title }).join(' · ')
        : 'Choose up to three chairs.'
      bar.hidden = selected.length === 0
      openButton.disabled = selected.length < 2
      toggles.forEach(function (toggle) {
        toggle.disabled = selected.length >= 3 && !toggle.checked
      })
    }

    function renderDialog () {
      var columns = selected.map(function (item) {
        var image = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="320" height="320">'
          : ''
        return '<article>' +
          image +
          '<h3>' + escapeHtml(item.title) + '</h3>' +
          '<strong>' + escapeHtml(item.price) + '</strong>' +
          '<dl>' +
            '<div><dt>Best for</dt><dd>' + escapeHtml(item.bestFor) + '</dd></div>' +
            '<div><dt>Colours</dt><dd>' + escapeHtml(item.colours) + '</dd></div>' +
            '<div><dt>Availability</dt><dd>' + escapeHtml(item.availability) + '</dd></div>' +
          '</dl>' +
          '<a class="okdo-button okdo-button--primary" href="' + escapeHtml(item.url) + '">View chair</a>' +
        '</article>'
      }).join('')
      content.innerHTML = '<div class="okdo-compare-dialog__grid">' + columns + '</div>'
    }

    function clearSelection () {
      selected = []
      toggles.forEach(function (toggle) { toggle.checked = false })
      save()
      renderBar()
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('change', function () {
        var item = getCardData(toggle)
        if (!item) return
        if (toggle.checked) {
          if (selected.length >= 3) {
            toggle.checked = false
            return
          }
          selected.push(item)
        } else {
          selected = selected.filter(function (selectedItem) { return selectedItem.id !== item.id })
        }
        save()
        renderBar()
      })
    })

    try {
      var saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]')
      if (Array.isArray(saved)) {
        toggles.forEach(function (toggle) {
          var item = getCardData(toggle)
          if (item && saved.includes(item.id) && selected.length < 3) {
            toggle.checked = true
            selected.push(item)
          }
        })
      }
    } catch (error) {
      selected = []
    }

    openButton.addEventListener('click', function () {
      if (selected.length < 2) return
      renderDialog()
      dialog.showModal()
      window.okdoTrack?.('okdo_collection_compare_open', {
        count: selected.length,
      })
    })
    clearButton.addEventListener('click', clearSelection)
    closeButton.addEventListener('click', function () { dialog.close() })
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close()
    })
    renderBar()
  }

  function boot (root) {
    root.querySelectorAll('.okdo-brand-hero').forEach(bootHero)
    root.querySelectorAll('[data-okdo-chair-finder]').forEach(bootFinder)
    root.querySelectorAll('[data-okdo-product-banner-root]').forEach(bootProductBanner)
    root.querySelectorAll('[data-okdo-collection-root]').forEach(bootCollection)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document) })
  } else {
    boot(document)
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target)
  })
})()
